import React, { Component } from "react";
import relationshipbanner from "views/job-details/img/relationship-img.png";
import { connect } from "react-redux";
import Token from "api/Auth/auth";
import { setMgToken, setHcToken } from "store/Auth";
import store from "store.js";
import { getDetailsAction } from "store/JobList";


class EmployeeCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobdetails:'',
      isvideo:false,
      playing:false,
    };
  }
  async componentDidMount() {
    // let id = this.props.match.params.id;
    let id = this.props.id
    let HcToken = await Token.getToken();
    store.dispatch(setHcToken(HcToken));
    let MgToken = await Token.getTokenMagitt();
    store.dispatch(setMgToken(MgToken));
    let response = await this.props.getdetailsaction(id);
    // console.log(response.Data[0])
    this.setState({jobdetails:response.Data[0]})
    if(this.state.jobdetails.f_mediaType !== 'image'){
      this.setState({isvideo:false})
    }
  }
  render() {
    const { jobdetails } = this.state;
    return (
      <div>
        <card className="w-full drop-shadow flex rounded-12px mt-6 mb-12  p-12">
          <div className="flex items-center w-full">
            <div className="w-1/3	 border2px-f5f5f5-r	">
              <div className="chips-orange flex justify-center items-center font-semibold">
                <p className=" fsize12  textF06321 uppercase">
                  {jobdetails.Department || 'Commercial Banking'}
                </p>
              </div>

              <h1 className="fsize18 text262626 font-bold mt-2">
                {jobdetails.JobTitle}
              </h1>
            </div>

            <div className="w-5/12	">
              <div className="flex items-center">
                <div className="w-1/3 border2px-f5f5f5-r flex justify-center">
                  <div>
                    <p className="text707070 fsize14">Experience</p>
                    <h1 className="fsize18 text262626 font-bold mt-1">
                      {jobdetails.Experience || '0'} Years
                    </h1>
                  </div>
                </div>
                <div className="w-1/3  flex justify-center border2px-f5f5f5-r">
                  <div>
                    <p className="text707070 fsize14">Location</p>
                    <h1 className="fsize18 text262626 font-bold mt-1">
                      {jobdetails.Location || 'UNKNOWN'}
                    </h1>
                  </div>
                </div>
                <div className="w-1/3 border2px-f5f5f5-r flex justify-center">
                  <div>
                    <p className="text707070 fsize14">Level</p>
                    <h1 className="fsize18 text262626 font-bold mt-1">
                      Fresher
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-1/4 b flex justify-center">
              <div>
                <button className="applynow-btn font-medium fsize16 flex">
                  APPLY NOW
                </button>
              </div>
            </div>
          </div>
        </card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    
    getdetails: state.DETAILS.details.JOBDETAILS,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getdetailsaction: async (id) => await dispatch(getDetailsAction(id)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeCard);
